// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";  // from react-router v7
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();
    if (!user) {
        return <Navigate to="/login" replace />;
    }
    return children;
}
